import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import * as RSFSettingsActions from './rsf-settings.action';
import { GeneralSignalRResponse } from 'src/app/services/signal-r/general-signal-r-response';
import { SignalRService } from 'src/app/services/signal-r/signal-r.service';
import { SignalRAction } from 'src/app/services/signal-r/signalr-enums';
import { Channels } from 'src/app/store/channels';

@Injectable({
  providedIn: 'root'
})
export class RSFSettingsStoreAndListenersService {
  constructor(private store: Store, private signalRService: SignalRService) { }
  initStore() {
    this.store.dispatch(new RSFSettingsActions.RSFSettingsRefresh());
  }

  initListeners() {
    this.signalRService.hubConnection?.on(Channels.RSF_SETTINGS, (data: GeneralSignalRResponse) => {
      this.signalRService.setSender(data.userID);
      switch (data.action) {
        case SignalRAction.Add:
          this.store.dispatch(new RSFSettingsActions.RSFSettingsCreate(data.obj));
          break;

        case SignalRAction.Update:
          this.store.dispatch(new RSFSettingsActions.RSFSettingsUpdate(data.id, data.obj));
          break;

        case SignalRAction.Delete:
          this.store.dispatch(new RSFSettingsActions.RSFSettingsDelete(data.id));
          break;

        case SignalRAction.Get:
          this.store.dispatch(new RSFSettingsActions.RSFSettingsRefresh());
          break;

        case SignalRAction.RequestRefresh:
          this.store.dispatch(new RSFSettingsActions.RSFSettingsRefreshById(data.id));
          break;
      }
    });
  }
}
